module.exports = function(...args) {
    return new Date().getFullYear();
};



// WEBPACK FOOTER //
// ./src/handlebars-helpers/currentYear.js